module.exports = __webpack_public_path__ + "static/img/store1.9cdc12c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/store1.png
// module id = S22F
// module chunks = 1